import api from '../utils/api';

// Fetch all grade levels
export const getGradeLevels = async (headers) => {
  try {
    const response = await api.get('/api/gradelevels', headers);
    console.log("grade levels",response)
    return response.data;
  } catch (error) {
    console.error('Error fetching all grade levels:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific grade level by ID
export const getGradeLevelById = async (id, headers) => {
  try {
    const response = await api.get(`/api/gradelevels/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error fetching grade level with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new grade level
export const createGradeLevel = async (gradeLevelData, headers) => {
  console.log("datas", gradeLevelData);
  try {
    const response = await api.post('/api/gradelevels', gradeLevelData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating grade level:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing grade level
export const updateGradeLevel = async (id, gradeLevelData, headers) => {
  console.log("hello ");
  try {
    const response = await api.put(`/api/gradelevels/${id}`, gradeLevelData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating grade level with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a grade level
export const deleteGradeLevel = async (id, headers) => {
  try {
    const response = await api.delete(`/api/gradelevels/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting grade level with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
